module.exports = __webpack_public_path__ + "img/order_person.7008004c.png";